export default "__VITE_ASSET__0566d2b7__"